var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 123,
    height: 40,
    viewBox: "0 0 123 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.3301 20.2196V22.8372H55.3259L56.9548 20.2196H52.3301Z",
    fill: "url(#paint0_linear_4084_33620)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4338 22.8372H63.759V20.2196H59.2541C58.6175 20.2196 58.0446 20.3994 57.5278 20.7551C56.7601 21.2831 56.3781 21.9909 56.3781 22.8784V35.2997H59.4338V22.8372Z",
    fill: "url(#paint1_linear_4084_33620)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.862 29.1471V26.5295V26.5258H68.6983V22.8335H76.4762L77.9067 20.2159H68.5223C67.8857 20.2159 67.3128 20.3956 66.796 20.7514C66.0283 21.2794 65.6464 21.9871 65.6464 22.8747V32.6372C65.6464 33.2064 65.8299 33.7307 66.2006 34.2062C66.781 34.9327 67.5562 35.296 68.5223 35.296H77.9067L76.4762 32.6784H68.6983V29.1471H75.862Z",
    fill: "url(#paint2_linear_4084_33620)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7513 33.2963L90.4665 35.2997V35.3034H93.7207L89.2757 22.6837C88.6428 20.9236 87.6355 20.0399 86.2612 20.0249C84.8831 20.0399 83.872 20.9236 83.2242 22.6837L78.7979 35.3034H82.0521L86.2574 23.2791L88.8375 30.6787H84.7708L83.1418 33.2963H89.7513Z",
    fill: "url(#paint3_linear_4084_33620)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.585 32.6821C99.9781 32.6821 99.4164 32.4687 98.8997 32.0455C98.1582 31.4239 97.7875 30.6 97.7875 29.5665V25.9566C97.7875 25.2563 97.9859 24.6197 98.3829 24.0505C98.9371 23.2454 99.6711 22.8409 100.585 22.8409H102.607C102.712 22.8409 102.832 22.8484 102.963 22.8597C103.783 22.9645 104.423 23.3165 104.887 23.9119L107.528 21.8673C107.235 21.5902 106.839 21.3243 106.337 21.0734C105.135 20.5042 103.891 20.2196 102.607 20.2196H100.585C99.0082 20.2196 97.6452 20.7589 96.4955 21.8448C95.3309 22.9683 94.7505 24.3388 94.7505 25.9528V29.5628C94.7505 31.1093 95.301 32.4387 96.3982 33.5509C97.5478 34.7155 98.9446 35.296 100.585 35.296H102.607C103.056 35.296 103.551 35.2435 104.094 35.1387C105.644 34.8503 106.786 34.3523 107.528 33.652L104.887 31.6299C104.835 31.6935 104.768 31.7684 104.689 31.8471C104.12 32.405 103.427 32.6821 102.607 32.6821H100.585Z",
    fill: "url(#paint4_linear_4084_33620)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.44 35.2997H122.495H122.499V20.2196H119.443V26.5295H113.946L112.912 28.1772V20.2196H109.875V35.2997H112.912V29.1471H119.44V35.2997Z",
    fill: "url(#paint5_linear_4084_33620)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.05 4.17495C103.446 4.59084 103.144 5.14537 103.144 5.84483V13.52C103.144 13.9674 103.289 14.3833 103.578 14.7551C104.037 15.3285 104.648 15.6121 105.402 15.6121H112.768L111.649 13.5515H105.547V10.7726H111.171V8.71199H105.547V5.81332H111.649L112.768 3.75275H105.402C104.905 3.75275 104.453 3.89138 104.05 4.17495Z",
    fill: "url(#paint6_linear_4084_33620)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6449 3.75275H86.2608V15.6121H88.6449V3.75275Z",
    fill: "url(#paint7_linear_4084_33620)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0083 3.75275C80.5114 3.75275 80.0585 3.89138 79.6559 4.17495C79.052 4.59084 78.7501 5.14537 78.7501 5.84483V15.6121H81.1467V5.81332H84.5435V3.75275H81.0083Z",
    fill: "url(#paint8_linear_4084_33620)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2093 3.75275H75.5797V5.81332H77.9323L79.2093 3.75275Z",
    fill: "url(#paint9_linear_4084_33620)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7465 3.59521C56.6646 3.60782 55.872 4.30098 55.3625 5.6873H55.3688L51.8965 15.6121H54.4504L57.7528 6.15991L59.7783 11.9761H56.5828L55.3059 14.0367H60.4891L61.049 15.6121H63.6029L60.1117 5.6873C59.6148 4.30098 58.8285 3.60782 57.7465 3.59521Z",
    fill: "url(#paint10_linear_4084_33620)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9874 15.6121H70.5789L70.5852 15.6184C70.9375 15.6184 71.3275 15.5743 71.7552 15.4923C72.9692 15.2592 73.8688 14.8685 74.4475 14.3203L72.3779 12.726C72.3339 12.7764 72.2836 12.8331 72.2207 12.8961C71.7741 13.3309 71.2268 13.5515 70.5852 13.5515H68.9937C68.5219 13.5515 68.0753 13.3877 67.6727 13.0537C67.0877 12.5685 66.7984 11.9194 66.7984 11.1065V8.26459C66.7984 7.71006 66.9494 7.21225 67.2639 6.76484C67.7042 6.1284 68.2766 5.81332 68.9937 5.81332H70.5852H70.5852C70.6733 5.81332 70.7613 5.81332 70.8683 5.82593C71.5099 5.90785 72.0131 6.18511 72.3779 6.65142L74.4475 5.04455C74.2147 4.824 73.9065 4.61605 73.5102 4.42071C72.5667 3.97961 71.5917 3.75275 70.5852 3.75275H68.9937C67.7608 3.75275 66.6914 4.18125 65.7856 5.03195C64.8735 5.91415 64.4143 6.99169 64.4143 8.25828V11.1002C64.4143 12.3164 64.8421 13.3625 65.7039 14.2384C66.6034 15.1521 67.6979 15.6121 68.9874 15.6121Z",
    fill: "url(#paint11_linear_4084_33620)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.186 3.75275L93.6772 13.6775C94.1741 15.0638 94.9604 15.757 96.0423 15.7696C97.1243 15.757 97.9169 15.0638 98.4264 13.6775L101.899 3.75275H99.3448L96.0423 13.2049L92.7399 3.75275H90.186Z",
    fill: "url(#paint12_linear_4084_33620)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2823 13.9238H20.5898V28.5729H21.2823C25.9742 28.5729 29.818 28.4578 29.818 21.2695C29.818 14.0811 25.7814 13.9262 21.2823 13.9262V13.9238Z",
    fill: "#1F295C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0064 21.2663C34.0064 28.1424 28.931 29.0747 21.2785 29.0747H20.5859V35.4458C20.5859 38.4211 21.1506 39.5601 22.1871 39.9946H45.7048L34.2783 19.9935L33.8204 19.1904C33.9413 19.8151 34.0064 20.5008 34.0064 21.2617V21.2663Z",
    fill: "#1F295C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7808 35.5688V17.5803C16.7808 15.1803 16.3462 14.1518 14.8775 13.9639L11.4265 20.0039L0 40.0002H15.5374C16.4391 39.5023 16.7808 38.2366 16.7808 35.5665V35.5688Z",
    fill: "#1F295C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2807 13.4209H30.5228L22.854 0L15.1875 13.4209H21.2807Z",
    fill: "#1F295C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4084_33620",
    x1: 52.3301,
    y1: 27.6642,
    x2: 122.499,
    y2: 27.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4084_33620",
    x1: 52.3301,
    y1: 27.6642,
    x2: 122.499,
    y2: 27.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4084_33620",
    x1: 52.3301,
    y1: 27.6642,
    x2: 122.499,
    y2: 27.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4084_33620",
    x1: 52.3301,
    y1: 27.6642,
    x2: 122.499,
    y2: 27.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4084_33620",
    x1: 52.3301,
    y1: 27.6642,
    x2: 122.499,
    y2: 27.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4084_33620",
    x1: 52.3301,
    y1: 27.6642,
    x2: 122.499,
    y2: 27.6642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4084_33620",
    x1: 51.8965,
    y1: 9.68241,
    x2: 112.768,
    y2: 9.68241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4084_33620",
    x1: 51.8965,
    y1: 9.68241,
    x2: 112.768,
    y2: 9.68241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4084_33620",
    x1: 51.8965,
    y1: 9.68241,
    x2: 112.768,
    y2: 9.68241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4084_33620",
    x1: 51.8965,
    y1: 9.68241,
    x2: 112.768,
    y2: 9.68241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4084_33620",
    x1: 51.8965,
    y1: 9.68241,
    x2: 112.768,
    y2: 9.68241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4084_33620",
    x1: 51.8965,
    y1: 9.68241,
    x2: 112.768,
    y2: 9.68241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4084_33620",
    x1: 51.8965,
    y1: 9.68241,
    x2: 112.768,
    y2: 9.68241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login_logo.b47dbca290b75fa76b7ecd507d69d094.svg";
export { ForwardRef as ReactComponent };